import { calcBiorhythmsRange } from '@yadviga/shared'

interface Props {
  birthDate: string
  /** Days on each side of today to render. */
  radius?: number
}

/**
 * 30-day biorhythm line chart, today centred. Three curves (physical,
 * emotional, intellectual) drawn as SVG paths. Vertical "today" marker.
 */
export function BiorhythmsGraph({ birthDate, radius = 14 }: Props) {
  const today = new Date()
  const range = calcBiorhythmsRange(birthDate, today, radius)
  const width = 320
  const height = 120
  const padding = 6

  const xAt = (i: number) => padding + (i / (range.length - 1)) * (width - padding * 2)
  const yAt = (v: number) => height / 2 - (v * (height / 2 - padding))

  const path = (key: 'physical' | 'emotional' | 'intellectual'): string =>
    range
      .map((p, i) => `${i === 0 ? 'M' : 'L'} ${xAt(i).toFixed(1)} ${yAt(p.values[key]).toFixed(1)}`)
      .join(' ')

  const todayX = xAt(radius)

  return (
    <svg viewBox={`0 0 ${width} ${height}`} className="w-full" role="img" aria-label="Biorhythm graph">
      {/* zero line */}
      <line x1={padding} y1={height / 2} x2={width - padding} y2={height / 2} stroke="currentColor" strokeOpacity="0.15" strokeWidth="1" />
      {/* today marker */}
      <line x1={todayX} y1={padding} x2={todayX} y2={height - padding} stroke="currentColor" strokeOpacity="0.3" strokeDasharray="2 3" strokeWidth="1" />
      {/* physical = copper, emotional = blush, intellectual = sage-darker */}
      <path d={path('physical')}     stroke="#b56e3b" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <path d={path('emotional')}    stroke="#c97d7d" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <path d={path('intellectual')} stroke="#5a7560" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
